/* src/app/_shared/components/agenda-datepicker/agenda-datepicker.component.scss */
:host {
  --height: 40px;
}
.agenda-datepicker {
  display: grid;
  grid-template: 1fr/auto var(--height);
  grid-column-gap: calc(var(--space-right) / 2);
}
.agenda-datepicker .date-container {
  height: var(--height);
  padding: var(--space);
  border-radius: var(--radius);
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  font-weight: bold;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.agenda-datepicker .calendar-button {
  width: var(--height);
  height: var(--height);
  padding: var(--space-top) 0 var(--space-bottom) 0;
  border-radius: var(--radius);
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  text-align: center;
}
.agenda-datepicker .calendar-button ion-icon {
  margin-top: -3px;
  font-size: 24px;
}
.agenda-datepicker app-datepicker {
  --height: 0;
}
.agenda-datepicker app-datepicker ion-select {
  border: 0;
}
/*# sourceMappingURL=agenda-datepicker.component.css.map */
